
import Form from "./EditTicketForm";

const FormCreateTicket = ({ onClose,valuesToEdit , getValues})=>{


  
    // const axios = useAxios();

    // const handleSubmit = async (ticket) => {

    //     try {

    //         if (ticket._id) {
    //             await axios.put(`/tickets/${ticket._id}`, ticket)
    //         } else {
    //             await axios.post("/tickets", ticket);
    //         }

    //     } catch (error) {
    //         console.log(error)
    //     } finally {
    //       getValues();
    //     }

    // }

return (
        <Form onClose={()=>{getValues();onClose()}} values={valuesToEdit}/> 
)
}

export default FormCreateTicket